import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { Tooltip } from '@liveauctioneers/hammer-ui-core/tooltip';
import { ReactNode, useId } from 'react';

import { Amount } from '@/types/Amount';

type Props = {
    amount: Amount;
    bold?: boolean;
    infoText?: ReactNode;
    label: ReactNode;
};

export const InvoiceSummaryListRow = ({ amount, bold, infoText, label }: Props) => {
    const Text = bold ? H5 : BodySecondary;
    const triggerId = `invoice-row-info-${useId().replace(/:/g, '')}`;
    return (
        <div className="mb-sm flex w-full items-center justify-between">
            <div className="flex items-center">
                <Text>{label}</Text>
                {Boolean(infoText) && (
                    <>
                        <Info
                            className="inline-flex"
                            color="primary"
                            id={triggerId}
                            size="xs"
                        />
                        <Tooltip
                            anchorSelect={`#${triggerId}`}
                            place="top"
                        >
                            {infoText}
                        </Tooltip>
                    </>
                )}
            </div>
            <Text>
                <FormattedNumber
                    currency={amount.currency || 'USD'}
                    key="invoice-summary-list-row-amount"
                    maximumFractionDigits={2}
                    minimumFractionDigits={2}
                    style="currency"
                    value={amount.amount || 0}
                />
            </Text>
        </div>
    );
};
